import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ColaboradorService } from 'src/app/service/colaborador.service';
import { aplicarFiltrosConsulta } from 'src/app/util/consulta/wow-consulta.util';
import { Colaborador } from './colaborador';

@Component({
  selector: 'app-colaborador-consulta',
  templateUrl: './colaborador-consulta.component.html',
  styleUrls: [
    './colaborador-shared.scss',
    '../../util/conta-financeira/conta-financeira-consulta.scss',
  ],
})
export class ColaboradorConsultaComponent {

  colaboradores: Colaborador[] = [];
  tipoFiltros = ['ID', 'Nome', 'Departamento', 'Cargo'];
  tipoFiltro = 'ID';
  parametro = '';
  situacao: boolean | null = null;
  consultaRealizada = false;

  constructor(
    private service: ColaboradorService,
    private snackBar: MatSnackBar,
    private router: Router,
  ) { }

  consultar() {
    this.service.listar().subscribe(lista => {
      this.colaboradores = aplicarFiltrosConsulta(lista ?? [], this.tipoFiltro, this.parametro, this.situacao, {
        id: c => c.id,
        nome: c => {
          if (this.tipoFiltro === 'Departamento') {
            return c.departamentoNome;
          }
          if (this.tipoFiltro === 'Cargo') {
            return c.cargoNome;
          }
          return c.nome;
        },
        ativo: c => c.ativo !== false,
      });
      this.consultaRealizada = true;
    }, () => this.snackBar.open('Erro ao listar colaboradores.', 'ERRO', { duration: 2500 }));
  }

  novo() {
    this.router.navigate(['/colaborador/form']);
  }

  editar(item: Colaborador) {
    if (item.id) {
      this.router.navigate(['/colaborador/form', item.id]);
    }
  }

  inativar(item: Colaborador) {
    if (!item.id || !confirm('Inativar este colaborador?')) {
      return;
    }
    this.service.inativar(item.id).subscribe(() => {
      this.snackBar.open('Colaborador inativado.', 'OK', { duration: 2000 });
      this.consultar();
    });
  }
}
